import { render, staticRenderFns } from "./addOtherCompContract.vue?vue&type=template&id=3464d75d&scoped=true"
import script from "./addOtherCompContract.vue?vue&type=script&lang=js"
export * from "./addOtherCompContract.vue?vue&type=script&lang=js"
import style0 from "./addOtherCompContract.vue?vue&type=style&index=0&id=3464d75d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3464d75d",
  null
  
)

export default component.exports